import React from "react";
import { FormGroup } from "../../../components/form";
import { GetUserEmail, formatDate } from "../../CommonFunctions";
import { FormArrayConfig } from "../../enums/FormArrayConfig";

export const adminNotesForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "formArray",
      key: "adminNotes",
      config: FormArrayConfig.AutoAddField,
      mutateValues(formContext, initialValues, childModel) {
        if (!formContext.disabled && initialValues[0].dateCreated) {
          initialValues.unshift(childModel);
        }
        return initialValues;
      },
      fields: [
        {
          type: "component",
          body: ({ parentValues }) => (
            <div>
              {parentValues.initialNoteDate != undefined ? (
                <div className="notesValue w-full">
                  <div className="flex justify-content-between align-items-center">
                    <div>
                      {" "}
                      <span className="user-icon-black pr-2"></span>{" "}
                      <span>{parentValues.initialNoteUserCreated ? parentValues.initialNoteUserCreated : ""}</span>
                    </div>{" "}
                    <div>
                      <span className="time-stamp-black pr-2"></span>
                      <span> {parentValues.initialNoteDate ? formatDate(parentValues.initialNoteDate) : ""} </span>
                    </div>
                  </div>{" "}
                </div>
              ) : (
                <div></div>
              )}
            </div>
          ),
        },
        {
          type: "field",
          key: "note",
          fieldType: "textarea",
          props: {
            className: "mb-3",
          },
          label: "Administrative Notes",
          expressionProps: {
            disabled: (context, values, model, props) => {
              return values.adminNotes[props.index].dateCreated != null;
            },
          },
        },
        {
          type: "field",
          key: "initialNoteUserCreated",
          fieldType: "value",
          defaultValue: GetUserEmail(),
        },
      ],
    },
  ],
};
